
import RestSchedule from './rest-schedule.vue';
export default {
  name: "AttCalendar",
  components: {
    RestSchedule
  },
  props: {},
  created() {
    let t = this;

    let d = new Date();

    t.year = d.getFullYear();
    t.month = d.getMonth() + 1;

    t.holiday = t.dict.holiday[t.month];
  },
  activated() { },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {

      let t = this;

      if (t.U.clock_in_reviewer == 1) {

        axios.get('unit').then(res => {
          if (res.data.status == 1) {

            let arr = res.data.options.items;

            arr.forEach(item => {
              item.children = [
              ];
              item.text = item.name;
            });

            t.list.unit = arr;

            t.dict.unit = listToDict(t.list.unit);

            axios.get('employee?role=4&_with=config').then(res => {
              if (res.data.status == 1) {
                let arr = res.data.options.items;
                t.list.employee = [];

                arr.forEach(e => {
                  e.fullname = e.name;

                  if (e.id == t.U.id) {
                    t.search.employee = e;
                    t.config = e.config;
                    e.fullname += " (私)";
                  }
                  e.text = e.fullname;
                  t.list.employee.push(e);

                  if (e.config) {
                    let unit = t.dict.unit[e.config.unit_id];
                    if (unit) {
                      unit.children.push(e);
                    }
                    else {
                      this.list.unit[0].children.push(e);
                    }
                  }
                  else {
                    this.list.unit[0].children.push(e);
                  }

                });

                if (t.list.unit[0].children.length == 0) {
                  t.list.unit.remove(t.list.unit[0]);
                }

                t.list.unit2 = [];
                t.list.unit.forEach(unit => {
                  if (unit.children.length > 0) {
                    t.list.unit2.push(unit);
                  }
                });

                t.dict.employee = listToDict(t.list.employee);

                t.loadMonthlyStats();
              }
            });
          }
        });
      } else {
        axios.get('employeeConfig?employee_id=' + t.U.id).then(res => {
          if (res.data.status == 1) {
            if (res.data.options.items && res.data.options.items.length > 0)
              t.config = res.data.options.items[0];

            t.loadMonthlyStats();
          }
        });
      }
    },

    minusMonth() {
      let t = this;
      let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), -1);
      t.month = r.getMonth() + 1;
      t.year = r.getFullYear();
      t.loadMonthlyStats();
    },

    plusMonth() {
      let t = this;
      let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), 1);
      t.month = r.getMonth() + 1;
      t.year = r.getFullYear();
      t.loadMonthlyStats();
    },

    loadMonthlyStats() {
      let t = this;

      let dayIndexs = ["日", "月", "火", "水", "木", "金", "土"];

      t.list.dateGrid.clear();

      let params = {};

      if (t.search.employee) {
        params.employee_id = t.search.employee.id;
      }

      t.list.dateGrid = [];
      t.list.placeholder = [];
      t.holiday = t.dict.holiday[t.month];

      if(t.holiday){
        t.holiday.left = t.holiday.days;
      }

      t.stats = {
        field_work_left: 0,
        rest_day_left: 0,
        sup_left: 0,
        dynamic_rest_day_left: 0,
      };

      t.stats.field_work_left = Number(t.config.monthly_field_work_times);
      t.stats.sup_left = Number(t.config.monthly_att_modify_times);
      t.stats.dynamic_rest_day_left = Number(t.config.monthly_dynamic_rest_day);

      axios
        .get("clockIn/loadMonthlyStats/" + t.year + '/' + t.month, { params: params })
        .then((res) => {
          if (res.data.status == 1) {

            let static_rest_day = [0, 6];

            if (t.config) {

              static_rest_day = t.config.static_rest_day.split(',');

              t.list.rest_day.forEach(item => {

                item.static_rest = false;

                if (static_rest_day.indexOf(item.id.toString()) > -1)
                  item.static_rest = true;

              });
            }

            let dictDate = {};

            let today = Date.today();
            let todayText = today.format("MM/dd");

            let day = getDaysInMonth(t.year, t.month);

            let dictSup = listToDict(res.data.options.sups ?? {}, "date");

            let dictFieldWork = listToDict(res.data.options.field_works ?? {}, "date");

            let dictLeave = listToDict(res.data.options.leaves ?? {}, "date");

            let dictShift = listToDict(res.data.options.shifts ?? {}, "date");

            if (res.data.options.field_works)
              t.stats.field_work_left -= res.data.options.field_works.length;

            if (res.data.options.sups)
              t.stats.sup_left -= res.data.options.sups.length;

            if (res.data.options.shift)
              t.stats.dynamic_rest_day_left -= res.data.options.shift.length;

            for (let i = 0; i < day; i++) {
              let curDate = new Date(t.year, t.month - 1, i + 1);
              let fullDateText = curDate.format("yyyy-MM-dd");
              let date = curDate.format("MM/dd");
              let item = {
                full_date: fullDateText,
                date: date,
                day_index_text: dayIndexs[curDate.getDay()],
                day_index: curDate.getDay(),
                is_today: date == todayText,
                is_future: curDate > today,
                is_past: curDate < today,
                clocks: [],

                clock_in: null,
                clock_out: null,

                is_late: false,
                late_minutes: 0,
                is_early: false,
                early_minutes: 0,

                daily_working_hour: 0,

                sup: null,
                field_work: null,
                leave: null,
                leaveReq: null,
                shift: null,

                static_rest: static_rest_day.indexOf(curDate.getDay().toString()) > -1,

                work_date: null,
                restDateItem: null,
                dynamic_rest: 0,

                f: {
                  rest_to_work: 0,
                  rest_date: '',
                },

                schedule: null
              };

              item.sup = dictSup[fullDateText];
              item.field_work = dictFieldWork[fullDateText];
              item.leaveReq = dictLeave[fullDateText];
              item.shift = dictShift[fullDateText];

              t.list.dateGrid.push(item);
              dictDate[date] = item;
            }

            let days = new Date(t.list.dateGrid[0].full_date).getDay();

            t.list.placeholder = [];

            if (days == 0) {
              days = 6;
            } else {
              days--;
            }

            for (let j = 0; j < days; j++) {
              t.list.placeholder.push("");
            }

            let arr = res.data.options.items;

            arr.forEach((clock_in) => {
              let date = new Date(clock_in.date).format("MM/dd");
              let item = dictDate[date];

              item.clocks.push(clock_in);
            });

            if (res.data.options.schedule) {
              let schedule = res.data.options.schedule;
              let dates = JSON.parse(schedule.data);

              dates.forEach(dateItem => {
                let dateKey = new Date(dateItem.date).format('MM/dd');
                let dateGrid = dictDate[dateKey];
                if (dateGrid) {
                  dateGrid.schedule = dateItem;

                  if (t.holiday && dateItem.work == 3) {
                    t.holiday.left--;
                  }

                  if (dateItem.work == 1 || dateItem.work == 2) {
                    dateGrid.static_rest = 0;
                  }
                  if (dateItem.rest_to_work == 1) {
                    t.stats.dynamic_rest_day_left--;
                    dateGrid.f.rest_to_work = 1;
                    dateGrid.f.rest_date = dateItem.rest_date;
                    let dateKey2 = new Date(dateGrid.f.rest_date).format('MM/dd');
                    let dateGrid2 = dictDate[dateKey2];
                    dateGrid2.dynamic_rest = 1;
                    dateGrid2.work_date = dateItem.date;
                  }
                }
                else {
                  if (dateItem.rest_to_work == 1) {
                    let dateKey2 = new Date(dateItem.rest_date).format('MM/dd');
                    let dateGrid2 = dictDate[dateKey2];
                    if (dateGrid2) {
                      dateGrid2.dynamic_rest = 1;
                      dateGrid2.work_date = dateItem.date;
                    }
                  }
                }
              });
            }
            else {
              // A.err('今月の勤務表が存在しません。管理者に連絡してください。');
            }

            t.list.dateGrid.forEach((item) => {

              let toRemove = [];

              let dict = {};

              item.clocks.forEach(clockData => {
                if (!dict[clockData.type]) {
                  dict[clockData.type] = clockData;
                }
                else {
                  if (clockData.sup_id && !dict[clockData.type].sup_id) {
                    toRemove.push(dict[clockData.type]);
                  }
                  else if (!clockData.sup_id && dict[clockData.type].sup_id) {
                    toRemove.push(clockData);
                  }
                  else if (clockData.sup_id && dict[clockData.type].sup_id) {

                    if (clockData.sup_id > dict[clockData.type].sup_id) {
                      toRemove.push(dict[clockData.type]);
                    }
                    else {
                      toRemove.push(clockData);
                    }
                  }
                }
              });

              toRemove.forEach(_item => {
                item.clocks.remove(_item);
              });

              dict = listToDict(item.clocks, 'type');

              item.clock_in = dict[1];
              item.clock_out = dict[2];

              if (item.clock_in || item.clock_out) {
                item.static_rest = 0;
              }

              if (item.clock_in && item.clock_out && item.schedule) {

                let start = new Date(item.full_date + " " + item.schedule.start_time);
                let end = new Date(item.full_date + " " + item.schedule.end_time);
                let clock_in = new Date(item.clock_in.date + " " + item.clock_in.time);
                let clock_out = new Date(item.clock_out.date + " " + item.clock_out.time);

                if (item.clock_in.day == 1) {
                  clock_in.setDate(clock_in.getDate() - 1);
                }

                if (start.valueOf() + 10 * 60 * 1000 < clock_in.valueOf()) {
                  item.is_late = true;
                  item.late_minutes = Math.floor(
                    (clock_in.valueOf() - start.valueOf()) / 60.0 / 1000
                  );
                }

                if (end.valueOf() > clock_out.valueOf()) {
                  item.is_early = true;
                  item.early_minutes = Math.floor(
                    (end.valueOf() - clock_out.valueOf()) / 60.0 / 1000
                  );
                }

                let minutes = Math.floor(
                  (clock_out.valueOf() - end.valueOf()) / 60.0 / 1000
                );

                if (minutes >= 0) {
                  item.external_minutes = minutes;
                }

                let hour = (
                  (clock_out -
                    clock_in -
                    60 * 60.0 * 1000.0) /
                  1000.0 /
                  60 /
                  60
                ).toFixed(1);

                item.daily_working_hour = hour;
              }

              if (item.shift) {
                let date = new Date(item.shift.rest_date).format("MM/dd");
                if (dictDate[date]) {
                  dictDate[date].dynamic_rest = 1;
                  dictDate[date].work_date = item.full_date;
                }
              }

              if (item.leaveReq) {
                item.leaveReq.leave_data = JSON.parse(item.leaveReq.leave_data);
                item.leaveReq.leave_data.forEach(leaveDateItem => {
                  let date = new Date(leaveDateItem.date).format("MM/dd");
                  if (dictDate[date]) {
                    dictDate[date].leave = leaveDateItem;
                    dictDate[date].leave.type = item.leaveReq.type;
                  }
                });
              }

            });

            // t.showDetails(t.list.dateGrid[10]);
            // t.showDateGridEditor = false;
            // t.makeSup();
          }
        });
    },

    showDetails(item) {
      let t = this;

      t.item = item;

      if (t.item.is_future || t.item.is_today) {
        if (t.item.sup) {
          t.makeSup(t.item);
        } else if (t.item.field_work) {
          t.makeFieldWork(t.item);
        }

        return;
      }

      // t.showDateGridEditor = true;
    },

    makeSup(item) {
      let t = this;

      t.item = item;

      t.f = {
        time: "--:--",
        time_description: "",
        time2: "--:--",
        time2_description: "",
        date: "",
      };

      if (t.item.sup) {
        t.f.time = t.item.sup.time.substr(0, 5);
        t.f.time2 = t.item.sup.time2 ? t.item.sup.time2.substr(0, 5) : "--:--";
        t.f.description = t.item.sup.description;
      }

      t.$forceUpdate();

      t.showSupEditor = true;
    },

    makeFieldWork(item) {
      let t = this;

      t.item = item;

      t.f2 = {
        clock_in: false,
        clock_in_description: "",
        clock_out: false,
        clock_out_description: "",
        date: "",
      };

      if (t.item.field_work) {
        t.f2.clock_in = t.item.field_work.clock_in;
        t.f2.clock_in_description = t.item.field_work.clock_in_description;
        t.f2.clock_out = t.item.field_work.clock_out;
        t.f2.clock_out_description = t.item.field_work.clock_out_description;
      }

      t.$forceUpdate();

      t.showFieldWorkEditor = true;
    },

    submitSup() {
      let t = this;

      if (t.busying) return;

      t.f.date = t.item.full_date;

      if (t.f.time == "--:--" && t.f.time2 == "--:--") {
        A.err(t.t("出勤/退勤時間を選択してください"));
        return;
      }

      if (t.f.time == t.f.time2) {
        A.err(t.t("出勤時間と退勤時間は一致してはいけません"));
        return;
      }

      if (t.f.time != "--:--" && !t.f.time_description) {
        A.err(t.t("出勤時間変更理由を述べてください"));
        return;
      }

      if (t.f.time2 != "--:--" && !t.f.time2_description) {
        A.err(t.t("退勤時間変更理由を述べてください"));
        return;
      }

      t.busying = true;

      axios.post("clockIn/submitSup", t.f).then((res) => {
        t.busying = false;

        if (res.data.status == 1) {
          t.loadMonthlyStats();

          t.showSupEditor = false;
        } else if (res.data.status == 2) {
          A.err(t.t("本月の補刻回数がすでに使い果たされました"));
        } else if (res.data.status == 3) {
          A.err(
            t.t("当日の補刻申請がありますので、重複して提出しないでください")
          );
        }
      });
    },

    cancelSup() {
      let t = this;

      A.safety("この申請をキャンセルしてもよろしいですか？").then((res) => {
        if (res.isConfirmed) {
          if (t.busying)
            return;

          t.busying = true;

          axios.post("clockIn/cancelSup/" + t.item.sup.id).then((res) => {
            t.busying = false;

            if (res.data.status == 1) {
              t.item.sup = null;
              t.showSupEditor = false;
            }
          });
        }
      });
    },

    submitFieldWork() {
      let t = this;

      if (t.busying) return;

      t.f2.date = t.item.full_date;

      if (t.f2.clock_in && !t.f2.clock_in_description) {
        A.err(t.t("直行場所と理由を述べてください。"));
        return;
      }

      if (t.f2.clock_out && !t.f2.clock_out_description) {
        A.err(t.t("直帰場所と理由を述べてください。"));
        return;
      }

      t.busying = true;

      axios.post("clockIn/submitFieldWork", t.f2).then((res) => {
        t.busying = false;

        if (res.data.status == 1) {
          t.loadMonthlyStats();

          t.showFieldWorkEditor = false;
        } else if (res.data.status == 2) {
          A.err(
            "今月の申請の回数が制限に達しました。"
          );
        } else if (res.data.status == 3) {
          A.err(
            "当日の申請はすでに提出されています。"
          );
        }
      });
    },

    cancelFieldWork() {

      let t = this;

      A.safety("この申請をキャンセルしてもよろしいですか？").then(
        (res) => {
          if (res.isConfirmed) {
            if (t.busying)
              return;

            t.busying = true;

            axios
              .post("clockIn/cancelFieldWork/" + t.item.field_work.id)
              .then((res) => {

                t.busying = false;

                if (res.data.status == 1) {
                  t.item.field_work = null;
                  t.showFieldWorkEditor = false;
                }
              });
          }
        }
      );
    },

    // selectEmployee(v) {
    //   this.search.employee = v;
    //   this.config = v.config;
    //   this.showEmployeeSelector = false;
    //   this.loadMonthlyStats();
    // },

    selectEmployee(e, arr, v) {

      if (!v) {
        v = this.list.unit2[arr[0]].children[arr[1]];
      }

      this.search.employee = v;
      this.config = v.config;
      this.showEmployeeSelector = false;
      this.loadMonthlyStats();

    },

    setAsWorkDay(item) {

      if (item != this.workDateItem && this.picking) {
        A.err((new Date(this.workDateItem.date)).format('M/d') + "の振替休日の選択中です。<br>選択を完了するか、リセットをクリックしてから操作を続けてください。");
        return;
      }
      if (item.f.rest_to_work == 1) {
        item.f.rest_to_work = 0;
        item.f.rest_date = '';
        if (item.restDateItem) {
          item.restDateItem.dynamic_rest = 0;
          item.work_date = null;
        }
        this.picking = false;
        this.workDateItem = null;
      }
      else {
        item.f.rest_to_work = 1;
        this.workDateItem = item;
        this.picking = true;
      }
    },

    selectRestDate(item) {

      let t = this;

      if (t.busying)
        return;

      t.busying = true;

      item.dynamic_rest = 1;
      item.work_date = t.workDateItem.date;

      t.workDateItem.f.rest_date = item.full_date;
      t.workDateItem.restDateItem = item;

      t.picking = false;
      t.showShiftPopup = true;
    },

    restShift() {

      let t = this;

      t.busying = false;

      t.workDateItem.restDateItem.dynamic_rest = 0;
      t.workDateItem.restDateItem.work_date = '';

      t.workDateItem.f.rest_to_work = 0;
      t.workDateItem.f.rest_date = '';
      t.workDateItem.restDateItem = null;

      t.showShiftPopup = false;

    },

    submitShift() {

      let t = this;

      let f = {
        employee_id: t.U.id,
        date: t.workDateItem.full_date,
        rest_date: t.workDateItem.f.rest_date,
        description: t.f3.description
      };

      axios.post('clockIn/submitShift', f).then(res => {
        t.busying = false;
        if (res.data.status == 1) {
          t.f3.description = '';
          A.show('申請が成功しました。', '休み変更', 'success');
          t.workDateItem.shift = res.data.options.item;
          t.showShiftPopup = false;
        }
      });

    },

    showShift(item) {
      this.item = item;
      this.showShiftPopup = true;
    },

    cancelShift() {

      let t = this;

      A.safety("この申請をキャンセルしてもよろしいですか？").then(
        (res) => {
          if (res.isConfirmed) {

            if (t.busying)
              return;

            t.busying = true;

            t.showShiftPopup = false;

            axios.post('clockIn/cancelShift/' + t.item.shift.id).then(res => {

              t.busying = false;

              if (res.data.status == 1) {
                A.show('休み変更の申請がキャンセルされました。', '', 'success');
                t.loadMonthlyStats();
              }
            });
          }

        });
    },

    goToRestSchedule() {
      this.view = 'rest';
    },


    showLeave(item) {
      this.item = item;
      this.showLeavePopup = true;
    },

    cancelLeave() {

      let t = this;

      A.safety("この申請をキャンセルしてもよろしいですか？").then(
        (res) => {
          if (res.isConfirmed) {

            if (t.busying)
              return;

            t.busying = true;

            t.showShiftPopup = false;

            axios.post('clockIn/cancelLeave/' + t.item.shift.id).then(res => {

              t.busying = false;

              if (res.data.status == 1) {
                A.show('休暇の申請がキャンセルされました。', '', 'success');
                t.loadMonthlyStats();
              }
            });
          }

        });
    },

  },
  data() {
    return {
      workDateItem: null,
      picking: false,
      config: null,
      ready: false,
      busying: false,
      year: 0,
      month: 0,
      holiday: null,
      tog: {
        showTime1: false,
        showTime2: false
      },
      dict: {
        employee: {},
        holiday: {
          5: {
            days: 3,
            name: 'GW',
            left: 3
          },
          8: {
            days: 3,
            name: '盆休',
            left: 3
          }
        },
      },
      list: {
        unit: [],
        unit2: [],
        dateGrid: [],
        placeholder: [],
        employee: [],
        rest_day: [
          { id: 1, text: "月" },
          { id: 2, text: "火" },
          { id: 3, text: "水" },
          { id: 4, text: "木" },
          { id: 5, text: "金" },
          { id: 6, text: "土" },
          { id: 0, text: "日" },
        ],
      },
      work_time: null,
      item: null,
      showDateGridEditor: false,
      showFieldWorkEditor: false,
      showSupEditor: false,
      showShiftPopup: false,
      showLeavePopup: false,
      showTimePopover1: false,
      showTimePopover2: false,
      f: {
        time: "--:--",
        time_description: "",
        time2: "--:--",
        time2_description: "",
        date: "",
      },
      f2: {
        clock_in: false,
        clock_out: false,
        clock_in_description: "",
        clock_out_description: "",
        date: "",
      },
      f3: {
        description: ''
      },
      showEmployeeSelector: false,
      search: {
        employee: null,
      },
      stats: {
        field_work_left: 0,
        rest_day_left: 0,
        sup_left: 0,
        dynamic_rest_day_left: 0,
      },
      view: 'calendar'
    };
  },
};
